import type { ActionTree, ActionContext, Module, MutationTree } from 'vuex';
import type { AxiosResponse } from 'axios';

import { NavigationModuleConstant, StorageConstant } from '../../constants';
import { navigationService } from '../../services/navigationService';
import { storageService } from '@life-time-inc/enterprise-framework-core';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

interface INavigationState {
	navigation: ltFramework.INavigation;
}

const NavigationState: INavigationState = {
	navigation: {
		pages: [],
		initialized: false
	} as ltFramework.INavigation
};

const { action, mutation } = NavigationModuleConstant;

const NavigationMutations: MutationTree<INavigationState> = {
	[mutation.setNavigation](state: INavigationState, payload: ltFramework.INavigation) {
		state.navigation = payload;
	}
};

const NavigationActions: ActionTree<INavigationState, ltFramework.IRootState> = {
	[action.initialize]({
		commit
	}: ActionContext<INavigationState, ltFramework.IRootState>): Promise<void> {
		const storageNav: ltFramework.IPage[] = storageService.sessionGet<ltFramework.IPage[]>(
			StorageConstant.navigation
		) as ltFramework.IPage[];

		if (!storageNav) {
			return navigationService
				.getNavigation()
				.then((response: AxiosResponse<ltFramework.IPage[]>) => {
					const navigation: ltFramework.INavigation = {
						pages: response.data,
						initialized: true
					};

					storageService.sessionSet(StorageConstant.navigation, response.data);

					commit(mutation.setNavigation, navigation);
				});
		}

		return new Promise<void>((resolve) => {
			const navigation: ltFramework.INavigation = {
				pages: storageNav,
				initialized: true
			};

			commit(mutation.setNavigation, navigation);

			resolve();
		});
	}
};

export const NavigationModule: Module<INavigationState, ltFramework.IRootState> = {
	namespaced: true,
	state: NavigationState,
	actions: NavigationActions,
	mutations: NavigationMutations
};
